import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

/*
  For an <ng-content> wrapper, you'll also want to use CdkObserveContent.
  But directive composition only supports standalone directives, so we can't combine CdkObserveContent here

  See: https://material.angular.io/cdk/observers/api
*/

@Directive({
  selector: '[crmOnResize]',
  standalone: true,
})
export class OnResizeDirective {
  @HostListener('window:resize')
  onWindowResize() {
    this.resizeDetected.emit();
  }

  @Output() resizeDetected = new EventEmitter();
  resizeObserver!: ResizeObserver;

  constructor(private element: ElementRef) {
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.resizeDetected.emit();
      });
      this.resizeObserver.observe(this.element.nativeElement);
    }
  }
}
